import React, { useEffect, useRef } from 'react';
import { TextField } from '@mui/material';

/**
 * Engancha un `<input type="date">` a un valor de afuera SIN pisar lo que se está tipeando.
 *
 * EL BUG QUE EVITA
 * Con un input de fecha controlado (`value={valor}`), tipear el año se cortaba en el primer
 * carácter. Mientras falta algún segmento (día, mes o año) el navegador reporta la fecha como
 * vacía; ese '' viajaba al estado, React lo volvía a escribir en el campo y el navegador borraba
 * los segmentos a medio tipear.
 *
 * LA SOLUCIÓN
 * El campo queda no controlado (el navegador maneja sus segmentos) y este efecto le empuja el
 * valor de afuera solo cuando es DISTINTO de lo que el campo muestra. Mientras se tipea, afuera
 * llega '' y el campo también dice '', así que no se escribe nada y lo tipeado sobrevive. Cuando
 * el valor cambia de verdad (se resetea el formulario, se guardó, se cambió de trámite), sí se
 * escribe.
 *
 * Lo usan este campo y TarjetaFechaLiquidar: las dos tienen el mismo problema.
 */
export function useSincronizarFecha(valor) {
    const ref = useRef(null);
    useEffect(() => {
        const campo = ref.current;
        const esperado = valor || '';
        if (campo && campo.value !== esperado) {
            campo.value = esperado;
        }
    }, [valor]);
    return ref;
}

/**
 * Fecha de liquidar del trámite (tramite.fechaInicioEstimada), en el formulario de alta.
 *
 * POR QUÉ EXISTE
 * Es el dato que arma el listado "A liquidar": el mes en el que el trámite se va a poder iniciar, y
 * el que se imprime en el renglón LIQ de la carátula. Se carga al iniciar el trámite porque ese es
 * el momento en que el cliente lo dice ("vuelvo en marzo").
 *
 * Vacía no quiere decir que el trámite quede sin mes: si se abrió desde una atención que cierra
 * con "Inicia ahora", la fecha se completa sola con la del día al finalizar la atención (ver
 * TurnoRecepcionService.asignarFechaLiquidarSiIniciaAhora).
 */
export default function CampoFechaLiquidar({ valor, onChange, label = 'Fecha de liquidar (LIQ)' }) {
    const inputRef = useSincronizarFecha(valor);

    return (
        <TextField
            type="date"
            label={label}
            // No controlado a propósito: ver useSincronizarFecha.
            defaultValue={valor || ''}
            inputRef={inputRef}
            onChange={(e) => onChange(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
            helperText="Opcional. Con fecha, el trámite queda en «A liquidar» esperando ese mes. Si la atención cierra con «Inicia ahora», toma la fecha del día."
        />
    );
}
